import React from 'react';
import PropTypes from 'prop-types';
import css from './ItemDescriptionCard.desktop.scss';
import { FormattedMessage as Translation } from 'react-intl';
import { Card } from 'panamera-react-ui';
import SingleParameter from './SingleParameter';
import MultiParameter from './MultiParameter';
import classnames from 'classnames';
import { getExternalSource, parameterToMap } from 'Helpers/item';
import { isMobile } from 'Helpers/devices';

class ItemDescriptionCard extends React.Component {
    static propTypes = {
        description: PropTypes.string,
        parameters: PropTypes.array.isRequired,
        isLamudi: PropTypes.bool
    };

    getItemParameters = () => {
        const newParameters = parameterToMap(this.props.parameters);
        const parametersToShow = newParameters.map(prop => {
            const WrapperComponent = (prop.type === 'multi' && prop.values)
                ? MultiParameter
                : SingleParameter;

            return (
                <WrapperComponent
                    key={ prop.key }
                    keyId={ prop.key }
                    keyName={ prop.key_name }
                    formattedValue={ prop.formatted_value }
                    valueName={ prop.value_name }
                    values={ prop.values || null }
                />
            );
        });

        return (
            <div data-aut-id="itemParams" className={ css.parametersSection }>
                <div className={ css.parametersCol }>
                    { parametersToShow }
                </div>
            </div>
        );
    }

    render() {
        const descriptions = this.props.description.split('\n');
        const isDescriptionAvailable = descriptions && descriptions.length > 0 && this.props.description !== '';
        const shouldShowSeparator = (this.props.parameters.length > 0 && isDescriptionAvailable) ? css.itemDescriptionSeparator : '';
        const externalSource = getExternalSource(this.props.parameters);

        if (this.props.parameters.length > 0 || isDescriptionAvailable) {
            return (
                <section className={ `${css.itemDescription}` }>
                    <Card contentClassName={ css.cardContent }>
                        { this.props.parameters.length > 0 && <h3 data-aut-id="itemDescriptonTitle" className={ css.itemTitle }>{ <Translation id="details" /> }</h3> }
                        { this.props.parameters.length > 0 && this.getItemParameters() }
                        { isDescriptionAvailable && (
                            <React.Fragment>
                                <h3 data-aut-id="itemDescriptonTitle" className={ shouldShowSeparator }>
                                    { <Translation id="description" /> }
                                </h3>
                                <div data-aut-id="itemDescriptionContent">
                                    {
                                        descriptions.map((description, index) => (
                                            <p
                                                key={ index }
                                                className={ classnames({
                                                    [css.empty]: !description.trim().length
                                                }) }>
                                                {description}
                                            </p>
                                        ))
                                    }
                                </div>
                                { this.props.isLamudi && !isMobile && externalSource.label && externalSource.url && (
                                    <p className={ css.directLamudiLink }><Translation id="adsOrigin" /> <span><a href={ externalSource.url } target="_blank" rel="noopener noreferrer">{ externalSource.label }</a></span></p>
                                )}
                            </React.Fragment>
                        )}
                    </Card>
                </section>
            );
        }
        return '';
    }
}

export default ItemDescriptionCard;
